export const resetInsightsObj = () => {
  return {
    type: 'RESET_INSIGHTS_OBJ',
    payload: {},
  }
}
export const resetInsightsStatus = (reset) => {
  return {
    type: 'RESET_INSIGHTS_STATUS',
    payload: reset,
  }
}

export const insightsError = (error) => {
  return {
    type: 'INSIGHTS_ERROR',
    payload: error,
  }
}

export const getInsights = (data) => {
  return {
    type: 'GET_INSIGHTS',
    payload: data,
  }
}

export const sendInsights = (data) => {
  return {
    type: SEND_INSIGHTS,
    payload: data,
  }
}

export const setInsights = (data) => {
  return {
    type: 'SET_INSIGHTS',
    payload: data,
  }
}
export const setInsight = (data) => {
  return {
    type: 'SET_INSIGHT',
    payload: data,
  }
}
